import { useConfig } from '../../../../context/config-provider';

export function useCuracao() {
  const { site } = useConfig();

  return { id: site?.license?.id };
}
